@if (form()) {
  <div class="flex-column">
    <div class="flex-row align-center mat-h2 gap-sm">
      Offene-Posten-Import-Optionen
      @for (action of actions(); track action.controlAction) {
        <lib-dynamic-form-action
          [hideLabel]="true"
          [action]="action"
          (callActionFunction)="callActionFunction($event)"
        />
      }
    </div>

    <div class="flex-row align-center space-between">
      <div class="mat-h3">Allgemeine Einstellungen</div>
      <lib-help-icon (click)="showHelpForGeneralSettings()"/>
    </div>
    <mat-divider/>

    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.importMode]"
      [formData]="formData.importMode()"
    />
    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.format]"
      [formData]="formData.format()"
    />
    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.quoteChar]"
      [formData]="formData.quoteChar()"
    />
    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.delimiter]"
      [formData]="formData.delimiter()"
    />

    <br>

    <div class="flex-row align-center space-between">
      <div class="mat-h3">CSV-Kopfzeilen</div>
      <lib-help-icon (click)="showHelpForCsvHeaders()"/>
    </div>
    <mat-divider/>

    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.invoiceNumber]"
      [formData]="formData.invoiceNumber()"
    />
    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.date]"
      [formData]="formData.date()"
    />
    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.balance]"
      [formData]="formData.balance()"
    />
    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.debit]"
      [formData]="formData.debit()"
    />
    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.credit]"
      [formData]="formData.credit()"
    />
    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.debitCreditIdentifier]"
      [formData]="formData.debitCreditIdentifier()"
    />
    <br>


    <div class="flex-row align-center space-between">
      <div class="mat-h3">Debitor</div>
      <lib-help-icon (click)="showHelpForDebitor()"/>
    </div>
    <mat-divider/>

    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.debitor]"
      [formData]="formData.debitor()"
    />
    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.debitorFilter]"
      [formData]="formData.debitorFilter()"
    />

  </div>

}
<input
  #fileUpload
  style="display: none"
  type="file"
  accept=".json"
  (change)="uploadJson($event).subscribe()"
/>

